import * as types from "./types";
import { initialState } from "./initialState";

export default function limitReducer(state = initialState, action) {
  switch (action.type) {
    
    case types.API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case types.GET_AUDIT:
      return {
        ...state,
        uoplist: action.payload,
      };

   
    default:
      return state;
  }
}
